import React from 'react'

import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import PropTypes from 'prop-types'

import image from './images/slate_logo.png'

const useStyles = makeStyles(() => ({
  container: {
    width: '40px',
    height: '40px',
    borderRadius: 8,
  },
  background: {
    background: 'rgba(33, 150, 243, 0.08)',
  },
}))

const AvailabilityHeader = () => {
  const styles = useStyles()
  return (
    <Box
      display="flex"
      alignItems="center"
      pb={3}
    >
      <Box
        className={cn([styles.container, styles.background])}
        display="flex"
        alignItems="center"
        justifyContent="center"
        mr={1}
      >
        <img
          alt="Slate Logo"
          src={image}
        />
      </Box>
      <Typography
        variant="body2"
        color="textSecondary"
      >
        Available to&nbsp;
      </Typography>
      <Typography
        variant="body2"
        color="textPrimary"
      >
        <b>Slate</b>
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
      >
        &nbsp;users only
      </Typography>
    </Box>
  )
}

AvailabilityHeader.propTypes = {
  config: PropTypes.object,
}

export default AvailabilityHeader
